<template>
    <div>
      <v-list-item to="/admin">
        <v-list-item-icon>
          <v-icon color="primary">mdi-shield-crown</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Admin</v-list-item-title>
      </v-list-item>
      <v-divider class="mb-3 mt-2"></v-divider>
    </div>
</template>

<script>

export default {
  name: 'MitMenuAdmin',
  components: {
  },
  props: {
    userModel: Object
  }
}
</script>

<style lang="scss" scoped>
</style>
